import React from "react";
import EditableCell from "./EditableCell";

export const MAIN_COLUMNS = [
  {
    // Make an expander cell
    Header: () => null, // No header
    id: "expander", // It needs an ID
    Cell: ({ row }) => (
      // Use Cell to render an expander for each row.
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.

      <span {...row.getToggleRowExpandedProps()}>
        {row.isExpanded ? (
          <i className='fas fa-arrow-down'></i>
        ) : (
          <i className='fas fa-arrow-right'></i>
        )}
      </span>
    ),
  },
  {
    Header: "Code",
    Footer: "Code",
    accessor: "productCode",
    disableFilters: true,
  },

  {
    Header: "Product",
    Footer: "Product",
    accessor: "productName",
    disableFilters: true,
  },

  {
    Header: "Available In Stock",
    Footer: "Available In Stock",
    accessor: "fromWarehouse.availableInStock",
    disableFilters: true,
  },
  {
    Header: "On Order",
    Footer: "On Order",
    accessor: "fromWarehouse.onOrder",
    disableFilters: true,
  },

  {
    Header: "In Transfer",
    Footer: "In Transfer",
    accessor: "fromWarehouse.inTransfer",
    disableFilters: true,
  },
  {
    Header: "Reorder Point",
    Footer: "Reorder Point",
    accessor: "fromWarehouse.reorderPoint",
    disableFilters: true,
  },
  {
    Header: "Restock Level",
    Footer: "Restock Level",
    accessor: "fromWarehouse.restockLevel",
    disableFilters: true,
  },
];

export const SUB_COLUMNS = [
  {
    Header: "Warehouse",
    Footer: "Warehouse",
    accessor: "warehouseName",
    disableFilters: true,
  },

  {
    Header: "To be transferred",
    Footer: "To be transferred",
    accessor: "toBeTransferred",
    disableFilters: true,
    Cell: EditableCell,
  },

  {
    Header: "Available In Stock",
    Footer: "Available In Stock",
    accessor: "availableInStock",
    disableFilters: true,
  },
  {
    Header: "On Order",
    Footer: "On Order",
    accessor: "onOrder",
    disableFilters: true,
  },

  {
    Header: "In Transfer",
    Footer: "In Transfer",
    accessor: "inTransfer",
    disableFilters: true,
  },
  {
    Header: "Reorder Point",
    Footer: "Reorder Point",
    accessor: "reOrderPoint",
    disableFilters: true,
  },
  {
    Header: "Restock Level",
    Footer: "Restock Level",
    accessor: "reStockLevel",
    disableFilters: true,
  },
];

export const VERIFY_DATA_COLUMNS = [
  {
    Header: "Product",
    accessor: "name",
    disableFilters: true,
  },

  {
    Header: "Amount",
    accessor: "amount",
    disableFilters: true,
  },
];

export const generateData = (reports, reportType) => {
  let requestData = [];
  let verifyData = [];

  reports.forEach((report) => {
    const distnation = report.toWarehouses;

    distnation.forEach((dis) => {
      if (dis.toBeTransferred) {
        const newFile = [...requestData];
        const isAdded = newFile.find(
          (e) => e.warehouseToID === dis.warehouseId
        );
        const indexItem = newFile.findIndex(
          (e) => e.warehouseToID === dis.warehouseId
        );
        if (isAdded && indexItem !== -1) {
          isAdded[`productID${isAdded.lastCount + 1}`] = report.productId;
          isAdded[`amount${isAdded.lastCount + 1}`] = dis.toBeTransferred;
          isAdded.lastCount = isAdded.lastCount + 1;
          newFile[indexItem] = isAdded;
          verifyData[indexItem].products.push({
            name: report.productName,
            amount: dis.toBeTransferred,
          });
          requestData = newFile;
        } else {
          requestData.push({
            warehouseFromID: report.fromWarehouse.warehouseId,
            warehouseToID: dis.warehouseId,
            status: "CREATED",
            confirmed: 0,
            [`productID${1}`]: report.productId,
            [`amount${1}`]: dis.toBeTransferred,
            type:
              reportType === "transferOrder" ? "TRANSFER_ORDER" : "TRANSFER",
            lastCount: 1,
          });

          verifyData.push({
            location: { name: dis.warehouseName, id: dis.warehouseId },
            products: [
              { name: report.productName, amount: dis.toBeTransferred },
            ],
          });
        }
      }
    });
  });

  return {
    requestData,
    verifyData,
  };
};
